import React, { PureComponent } from 'react';
import WND from './WND.js';
import ICONS from './ICONS';
import MENUBAR from './menus/MENUBAR';
import STATUSBAR from './STATUSBAR';
import BUTTON from './BUTTON';

export default class SHUTDOWN extends WND {
    constructor(props) {
        super(props);

        window.WINAPI.SetWindowLayer(this.props.hwnd, 1012); // Custom layer above shutdown veil
    }

    applicationContent() {
        return <div>
            <img src={ICONS.SHUTDOWN} />
            Are you sure you want to:

            <div>
                <BUTTON onPress={() => {
                    window.WINAPI.CloseWindow(this.props.hwnd);
                    window.WINAPI.InitiateSystemShutdown();
                }}>Yes</BUTTON>
                <BUTTON>No</BUTTON>
                <BUTTON>Help</BUTTON>
            </div>
        </div>;
    }

    icon() {
        return null;
    }

    title() {
        return "Shut Down Windows";
    }

    defaultSize() {
        return {h: 200, w: 350};
    }

    defaultPosition() {
        return 'center';
    }

    appearOnTaskbar() {
        return false;
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        window.WINAPI.AbortShutdown();
    }
}


// WEBPACK FOOTER //
// ./src/walleris/SHUTDOWN.js